import { CONNECT_REFERENTIALITY_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { getExperienceTracker } from '@confluence/experience-tracker/entry-points/getExperienceTracker.ts';

export interface ConnectReferentialityTransfer {
	extensionKey?: string;
	localId?: string;
	data?: unknown;
	isViewPage?: boolean;
}

type MaybeConnectReferentialityTransfer = ConnectReferentialityTransfer | null | undefined;

type ConnectReferentialityExperienceTrackerSupportApi = {
	isTrackable(transfer: MaybeConnectReferentialityTransfer): boolean;
	start(transfer: MaybeConnectReferentialityTransfer): void;
	succeed(): void;
	fail(messageOrError: string | Error): void;
};

const getError = (messageOrError: string | Error): Error => {
	if (messageOrError instanceof Error) {
		return messageOrError;
	}

	return new Error(messageOrError);
};

export const ConnectReferentialityExperienceTrackerSupport: ConnectReferentialityExperienceTrackerSupportApi =
	new (class ConnectReferentialityExperienceTrackerSupport {
		isTrackable(transfer: MaybeConnectReferentialityTransfer): boolean {
			return (
				Boolean(transfer?.extensionKey) && Boolean(transfer?.localId) && Boolean(transfer?.data)
			);
		}

		start(transfer: MaybeConnectReferentialityTransfer): void {
			getExperienceTracker().start({
				name: CONNECT_REFERENTIALITY_EXPERIENCE,
				attributes: {
					extensionKey: transfer?.extensionKey,
					isViewPage: transfer?.isViewPage,
				},
			});
		}

		succeed(): void {
			getExperienceTracker().succeed({
				name: CONNECT_REFERENTIALITY_EXPERIENCE,
			});
		}

		fail(messageOrError: string | Error): void {
			getExperienceTracker().fail({
				name: CONNECT_REFERENTIALITY_EXPERIENCE,
				error: getError(messageOrError),
			});
		}
	})();
